import React from 'react';
import styles from '../capitalExpenditure.module.scss';

const TableCell = ({
  children,
  className = '',
  colSpan,
  rowSpan
}) => {
  const props = {};
  if (colSpan) props.colSpan = colSpan;
  if (rowSpan) props.rowSpan = rowSpan;

  const resolvedClassName = String(className)
    .split(/\s+/)
    .filter(Boolean)
    .map((name) => styles[name] || name)
    .join(' ');
  
  return (
    <td className={resolvedClassName} {...props}>
      {children}
    </td>
  );
};

export default React.memo(TableCell);
